import React from "react";
import useLoaderStore from "../../store/loaderStore";
import { TopProgressBar, useDelayedLoading } from "../UI/loading";

const MODAL_SELECTOR = '.modal.show, [role="dialog"][data-state="open"], [role="alertdialog"]';

/**
 * App-wide request indicator: a 2px bar fixed under the header. It used to be
 * a full-screen spinner overlay; list pages now show their own skeletons and
 * the bar hides while one of them is active.
 *
 * The old overlay also blocked repeat clicks. That protection is kept, but
 * only while a modal is open (modal Save/Submit buttons rarely disable
 * themselves), via a transparent shield with a progress cursor.
 */
const GlobalLoader = () => {
  const active = useLoaderStore((s) => s.activeRequests > 0);
  const scoped = useLoaderStore((s) => s.scopedLoaders > 0);
  const showBar = useDelayedLoading(active && !scoped);
  const shieldModal = active && typeof document !== "undefined" && !!document.querySelector(MODAL_SELECTOR);

  return (
    <>
      <TopProgressBar active={showBar} fixed />
      {shieldModal && (
        <div
          aria-hidden="true"
          className="fixed inset-0 cursor-progress"
          style={{ zIndex: 2147483000 }}
        />
      )}
    </>
  );
};

export default GlobalLoader;
